/* eslint-disable spaced-comment,func-names,object-shorthand */
import React from 'react';
import request from 'superagent';
import Highcharts from 'highcharts';
import Chart from "../Chart";
import API from '../../../config/API';
import {getDataFilesCacheVersion} from "../../../helpers/cache";

require('highcharts-more')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data.src')(Highcharts);
const ReactHighcharts = require('react-highcharts').withHighcharts(Highcharts);

class CorporateDebtOutstanding extends Chart {

    componentDidMount() {
        request.get(API.getHost('data').concat(getDataFilesCacheVersion('/data-feeds/charts/MarketInsights/debt_outstanding.csv'))).then(data => {

            const options = {
                //set chart type
                chart: {
                    type: 'spline',
                    renderTo: 'debt_outstanding_container',
                    height: 600,
                    style: {
                        fontFamily: 'Exo'
                    }
                },
                //set title
                title: {
                    text: 'Corporate Debt Outstanding',
                    style: {
                        color: '#4D759E'
                    },
                    align: 'center'
                },
                //set x-axis
                xAxis: {
                    title: {
                        text: 'Date',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    gridLineWidth: 1,
                    //must set datetime for dates to be on the x-axis
                    type: 'datetime'
                },
                //set y-axis
                yAxis: {
                    title: {
                        text: 'Corporate Debt Outstanding ( Billions USD )',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    labels: {
                        //give y-axis labels commas for thousands place seperator
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, '', ',');
                        }
                    }
                },
                //set tooltip
                tooltip: {
                    valuePrefix: '$',
                    valueSuffix: ' Billion',
                    valueDecimals: 2,
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>'
                },
                //set legend
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    borderWidth: 1,
                    borderRadius: 5
                },
                //instantiate series
                series: [],
                //set colors for series
                colors: [
                    '#1D5B7F',
                    '#76b34d',
                    '#636569',
                    '#6786B8',
                    '#8244FF',
                    '#848486',
                    '#a42a47',
                    '#f8dc32',
                    '#2a84b9',
                    '#91c271',
                    '#818388',
                    '#8598c6',
                    '#cd3d60',
                    '#f6e35b',
                    '#11374c',
                    '#476c2e',
                    '#3b3d3f',
                    '#374f75',
                    '#621903',
                    '#ad9506'
                ],
                //set general plot options
                plotOptions: {
                    spline: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                //set name of chart downloads
                exporting: {
                    filename: 'MarketAxess_debt_outstanding',
                    //enable download icon
                    enabled: true,
                    //add image to chart download
                    chartOptions: {
                        chart: {
                            events: {
                                load: function () {
                                    this.renderer.image('/public/images/charts/marketaxess_logo2.gif', 90, 75, 300, 48).attr({
                                        opacity: 0.1
                                    }).add();
                                }
                            }
                        }
                    }
                },

                credits: {
                    enabled: false
                }
            };

            //names of labels in order of series. make sure they are the same as series header in data file
            const names = ['High Grade', 'High Yield'];
            //get csv file, multiply by 100 (divide by .01) and populate chart
            this.readCSV(options, data.text, 1000000000, names);

            this.setState({options});
        });
    }

    render() {
        if (!this.state.options) return null;

        return(
            <div className="container">
                <ReactHighcharts config={this.state.options}/>
            </div>
        );
    }
}

export default CorporateDebtOutstanding;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/CorporateDebtOutstanding.jsx